export const LATEST_ANTHROPIC_MODEL = 'claude-opus-4-7';
export const LATEST_ANTHROPIC_MODEL_SUPPORTS_THINKING = true;
